<template>
  <div class="header-swigi">
    <header class="section-header">
      <section class="header-main shadow-sm bg-white">
        <div class="container">
          <div class="row align-items-center p-1">
            <div
              class="col-4"
              style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                "
            >
              <a href="#" class="brand-wrap mb-0">
                <img
                  alt="#"
                  class="img-fluid"
                  :src="`${restaurant.logo ? 'https://space.monresto.menu/logos/'+restaurant.logo  : 'http://dev.monrest.menu/theme9/img/logo_web.png'}`"
                />
              </a>
              <div class="restau_infos">
                <span class="restau_title">{{ restaurant.name }}</span>
                <span class="menu_title">{{
                 name
                }}</span>
              </div>
            </div>

            <div class="col-8">
              <div class="d-flex align-items-center justify-content-end pr-5">
                <a
                  href="#"
                  class="widget-header mr-4 text-dark"
                >
                  <div
                    class="icon d-flex align-items-center"
                    style="position: relative;"
                  >
                    <i
                      class="feather-shopping-cart h6 mr-2 mb-0 shopping-cart"
                    ></i>
                    <span>Panier</span>
                    <span class="badge badge-success countItems">0</span>
                  </div>
                </a>

                <a class="toggle" href="#" style="top: -1px">
                  <span></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </header>
    <div class="d-none">
      <div class="bg-primary p-3 d-flex align-items-center">
        <a class="toggle togglew toggle-2" href="#"><span></span></a>
        <h4 class="font-weight-bold m-0 text-white">{{ restaurant.name }}</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["restaurant", "changeName", "currentLang", "newItem"],

  data() {
    return {
      // apiPath1: apiPath1,
      name: "name of the menu"
    };
  },
  methods: {},
  watch: {
    name(newVal) {
      this.changeName(newVal);
    }
  }
};
</script>
<style></style>
